import { Stack, Typography } from "@mui/material";
import VoucherSelection from ".";
import {
  MemberServiceOfferingStatus,
  MemberServiceOfferingType,
} from "@/services/core-api-adapter";

export default function VoucherSelectionExamples() {
  return (
    <Stack spacing={2}>
      <Typography variant="h2">Has vouchers</Typography>
      <VoucherSelection
        onBackButtonClick={() => {
          console.log("Back clicked");
        }}
        onContinueButtonClick={() => {
          console.log("Continue clicked");
        }}
        serviceOfferingUsageItems={[
          {
            id: "9a2e3ffa-ddba-4fd0-8fc4-a2f47b8145a4",
            serviceOfferingType: MemberServiceOfferingType.CONSULTATIONS,
            usageStatus: MemberServiceOfferingStatus.ACTIVE,
            availableFrom: "2025-05-21T07:42:56.836637+00:00",
            availableTo: "2028-05-21T07:41:34.159909+00:00",
            name: "Digital Doctor Consult",
            description: "Premium digital consultations with specialists",
            chargeCode: "DIGITAL_DOCTOR_CONSULT",
            offeringId: "683d9c2e-5afe-4dd5-99aa-f969d2ae0d4e",
            linkedBenefitType: "Product",
            linkedBenefitName: "Unu As-You-Go",
            document: "",
            voucherDetails: {
              voucherId: "9023d982-1c43-403b-aaff-2bc0941a7a0e",
              voucherCode: "NUEA-9825-QGVH",
              expiryDate: "2028-05-21T07:41:34+00:00",
            },
            discountVoucherDetails: null,
          },
          {
            id: "9a2e3ffa-ddba-4fd0-8fc4-a2f47b8145a4asdasdas",
            serviceOfferingType: MemberServiceOfferingType.CONSULTATIONS,
            usageStatus: MemberServiceOfferingStatus.ACTIVE,
            availableFrom: "2025-05-21T07:42:56.836637+00:00",
            availableTo: "2028-05-21T07:41:34.159909+00:00",
            name: "Digital Doctor Consult",
            description: "Premium digital consultations with specialists",
            chargeCode: "DIGITAL_DOCTOR_CONSULT",
            offeringId: "683d9c2e-5afe-4dd5-99aa-f969d2ae0d4e",
            linkedBenefitType: "Product",
            linkedBenefitName: "Unu As-You-Go",
            document: "",
            voucherDetails: {
              voucherId: "9023d982-1c43-403b-aaff-2bc0941a7a0e",
              voucherCode: "NUEA-9825-QGVH",
              expiryDate: "2028-05-21T07:41:34+00:00",
            },
            discountVoucherDetails: null,
          },
          {
            id: "9a2e3ffa-ddba-4fd0-8fc4-a2f47b8145a4asdasdasasdasfda",
            serviceOfferingType: MemberServiceOfferingType.PATHOLOGY,
            usageStatus: MemberServiceOfferingStatus.ACTIVE,
            availableFrom: "2025-05-21T07:42:56.836637+00:00",
            availableTo: "2028-05-21T07:41:34.159909+00:00",
            name: "Digital Doctor Consult",
            description: "Premium digital consultations with specialists",
            chargeCode: "PATH_HEPATITIS_B",
            offeringId: "683d9c2e-5afe-4dd5-99aa-f969d2ae0d4e",
            linkedBenefitType: "Product",
            linkedBenefitName: "Unu As-You-Go",
            document: "",
            voucherDetails: {
              voucherId: "9023d982-1c43-403b-aaff-2bc0941a7a0e",
              voucherCode: "NUEA-9825-QGVH",
              expiryDate: "2028-05-21T07:41:34+00:00",
            },
            discountVoucherDetails: null,
          },
        ]}
      />
      <Typography variant="h2">No vouchers (empty state)</Typography>
      <VoucherSelection
        onBackButtonClick={() => {
          console.log("Back clicked");
        }}
        onContinueButtonClick={() => {
          console.log("Continue clicked");
        }}
        serviceOfferingUsageItems={[]}
      />
    </Stack>
  );
}
